import { Picture } from 'ui/components/primitives/Image';
import { Items } from './Summary.components.styles';
import { SUMMARY_COMPONENTS_CONST } from './Summary.components.d';
import type { SummaryItemProps } from './Summary.components.d';

const ItemBase = ({
  image = {},
  name,
  price = '',
  priceTotal,
  productCode,
  quantity,
  ...props
}: SummaryItemProps['items'][number]) => (
  <Items.Row key={productCode} data-testid={SUMMARY_COMPONENTS_CONST.ITEM_TEST_ID} {...props}>
    <Items.Details>
      <Items.Image>
        <Picture
          alt={name}
          ratio="4x3"
          sources={[
            {
              srcSet: `${image.url}`,
            },
          ]}
          src={image.url}
        />
      </Items.Image>

      <Items.ProductInfo tabIndex={0} aria-label={`${productCode} ${name}`}>
        <small>{productCode}</small>
        <span>{name}</span>
      </Items.ProductInfo>

      <Items.CartInfo data-start tabIndex={0} aria-label={`Quantidade de itens ${quantity}`}>
        <small>Quantidade</small>
        <span>{quantity}</span>
      </Items.CartInfo>

      {price && (
        <Items.CartInfo>
          <small>Valor unidade</small>
          <span>{price}</span>
        </Items.CartInfo>
      )}

      <Items.CartInfo tabIndex={0} aria-label={`Total valor item ${priceTotal}`}>
        <small>{quantity > 1 ? `Total itens` : `Total item`}</small>
        <span>{priceTotal}</span>
      </Items.CartInfo>
    </Items.Details>
  </Items.Row>
);

export default ItemBase;
